import { Button, Col, Row } from "antd";
import React from "react";
import { NewsFeedData } from "../../helperFunction";
import "./styles.scss";

const NewsFeedAll = () => {
  return (
    <section className="news-feed-container">
      <div className="section-title-text">Check the feed</div>
      <div className="section-title-desc">
        #news #feed #facebook #twitter #instagram #youtube
      </div>
      <Row gutter={[24, 24]} className="news-feed-cards">
        {NewsFeedData?.map((e) => {
          return (
            <Col xs={24} sm={24} md={12} lg={8} xl={8} xxl={8}>
              <a href="https://twitter.com/?waqas3343" target="_blank">
                <div className="news-feed-single-card">
                  <img src={e?.newsImg} alt="#" className="news-feed-img" />
                  <div className="news-date-text">{e?.date}</div>
                  <div className="news-desc-text">{e?.newsDesc}</div>
                  <div className="icon-container">{e?.icon}</div>
                </div>
              </a>
            </Col>
          );
        })}
      </Row>

      <Button className="more-games-btn">Load More News</Button>
    </section>
  );
};

export default NewsFeedAll;
